import "../styles/app.scss";
import "./_images";
import { FooterBannerController } from "./components/footer-banner-controller";
import { SummitNotification } from "./components/summit-notification";
import { TabLink } from "./components/tab-link";
import { Header } from "./components/header";
import { BlogPosts } from "./components/blog-posts";
import { Reports } from "./components/reports";
import { InTheNews } from "./components/in-the-news";
import { VideoLibrary } from "./components/video-library";
import { PhotoGallery } from "./components/photo-gallery";
import { Events } from "./components/events";
import { Faq } from "./components/faq";
import { initEntranceAnimations } from "./components/entrance-animations";
import { initEqualHeights } from "./utils/equal-height";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new FooterBannerController();
    new SummitNotification();
    new Header();
    new TabLink();
    new BlogPosts();
    new Reports();
    new InTheNews();
    new VideoLibrary();
    new PhotoGallery();
    new Events();
    new Faq();
    initEntranceAnimations();
    initEqualHeights();
  },
  false,
);
